import { maxBy } from 'lodash';

import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';

interface DocumentWorkflowTrackerDocument {
  id: string;
}

export interface DocumentWorkflowTracker {
  createdAt: Date | string;
  documents?: readonly DocumentWorkflowTrackerDocument[] | null;
  kind: WorkflowTrackerKind;
  status: WorkflowTrackerStatus;
}

interface DocumentWorkflowTrackerInput {
  documentId: string | undefined;
  kind: WorkflowTrackerKind;
}

export function getMostRecentDocumentWorkflowTracker(
  trackers: readonly DocumentWorkflowTracker[],
  { documentId, kind }: DocumentWorkflowTrackerInput
): DocumentWorkflowTracker | null {
  if (!documentId) return null;

  return (
    maxBy(
      trackers.filter(
        (tracker) =>
          tracker.kind === kind &&
          tracker.documents?.some((document) => document.id === documentId)
      ),
      // Use createdAt so an older workflow's later status update cannot make it
      // the latest attempt for this document/kind.
      (tracker) => new Date(tracker.createdAt).getTime()
    ) ?? null
  );
}

export function isMostRecentDocumentWorkflowTrackerInProgress(
  trackers: readonly DocumentWorkflowTracker[],
  input: DocumentWorkflowTrackerInput
): boolean {
  return (
    getMostRecentDocumentWorkflowTracker(trackers, input)?.status ===
    WorkflowTrackerStatus.Started
  );
}
